// Match slug with partner slug in wp admin
// Dont forget to add the partners url to cors for creditsafe
// https://bitbucket.org/afonso-sweden/creditsafe-lookup/src/main/api/index.ts

export enum Business {
  kund = 'kund',
  byggmax = 'byggmax',
  skanska = 'skanska',
  string = 'string-furniture',
  hornbach = 'hornbach',
  forebygg = 'forebygg',
  doro = 'doro',
  elfa = 'elfa',
  kbygg = 'k-bygg',
  norrgavel = 'norrgavel',
  fargvaruhuset = 'fargvaruhuset',
  zaptec = 'zaptec',
  tesla = 'tesla',
  klint = 'klint',
  flyttsmart = 'flyttsmart',
  lg = 'lg',
  sparfonster = 'sparfonster',
  power = 'power',
  traningspartner = 'traningspartner',
  superfront = 'superfront',
  inet = 'inet',
  design24 = 'design24',
  netatonce = 'netatonce',
  bygghemma = 'bygghemma',
  badshop = 'badshop',
  byggshop = 'byggshop',
  golvshop = 'golvshop',
  golvpoolen = 'golvpoolen',
  webhallen = 'webhallen',
  homeroom = 'homeroom',
  pickyliving = 'picky-living',
  amina = 'amina',
  stgeorgesecuritystore = 'st-george-security-store',
  whiteawaygroup = 'whiteawaygroup',
  larmify = 'larmify',
}

type Icon = {
  url: string;
};

interface Customer {
  ID: number;
  post_title: string;
  post_name: string;
  post_type: string;
  filter: string;
  categories: CustomerCategory[];
  logo?: Icon;
  partner_url?: string;
  at_hemfixarna: boolean;
  info_title: string;
  widget_title?: string;
  info_text: string;
  checkout_title: string;
  checkout_trust_badges: { text: string }[];
  trust_badges: { text: string }[];
  source?: Source;
  password_protected: boolean;
}

interface CustomerCategory {
  id: string;
  name: string;
  widget_title?: string;
  icon: string;
  show_products: boolean;
  products: { fields: Product }[] | false;
  sub_categories: CustomerSubCategory[] | false;
  add_painting: boolean;
}

interface CustomerSubCategory {
  id: string;
  name: string;
  widget_title?: string;
  icon: string;
  products: { fields: Product }[];
  parent: string;
  add_painting: boolean;
}

interface Part {
  ID: number;
  post_author: number;
  post_date: Date;
  post_date_gmt: Date;
  post_content: string;
  post_title: string;
  post_excerpt: string;
  post_status: string;
  comment_status: string;
  ping_status: string;
  post_password: string;
  post_name: string;
  to_ping: string;
  pinged: string;
  post_modified: Date;
  post_modified_gmt: Date;
  post_content_filtered: string;
  post_parent: 0 | 1;
  guid: string;
  menu_order: 0;
  post_type: string;
  post_mime_type: string;
  comment_count: number;
  filter: string;
  price: number;
  title: string;
}

interface Product {
  ID: number;
  show_pdf: string;
  post_author: string;
  post_date: Date;
  post_date_gmt: Date;
  post_content: string;
  post_title: string;
  post_excerpt: string;
  post_status: string;
  comment_status: string;
  ping_status: string;
  post_password: string;
  post_name: string;
  to_ping: string;
  pinged: string;
  post_modified: Date;
  post_modified_gmt: Date;
  post_content_filtered: string;
  post_parent: 0;
  guid: string;
  menu_order: 0;
  post_type: string;
  post_mime_type: string;
  comment_count: 0;
  filter: string;
  price: number;
  icon?: Icon | string;
  parts?: Array<Part>;
  list: Array<{ bullet: string }>;
  terms: string;
  terms_checkout: string;
  terms_show_checkbox: boolean;
  rut: boolean;
  rot: boolean;
  green: boolean;
  hide_start_fee: boolean;
  description: string;
  category: string;
  title: string;
  invoice: string;
  invoice_price: string;
  invoice_description?: string;
  start_fee_obj: StartFee | null;
}

interface Service {
  ID: 41857;
  icon?: Icon | string;
  post_author: 34419;
  post_date: Date;
  post_date_gmt: Date;
  post_content: string;
  post_title: string;
  post_excerpt: string;
  post_status: string;
  comment_status: string;
  ping_status: string;
  post_password: string;
  post_name: string;
  to_ping: string;
  pinged: string;
  post_modified: Date;
  post_modified_gmt: Date;
  post_content_filtered: string;
  post_parent: 0;
  guid: string;
  menu_order: 0;
  post_type: 'service';
  post_mime_type: string;
  comment_count: 0;
  filter: string;
  products: Array<Product>;
}

interface Category {
  count: number;
  description: string;
  name: string;
  icon?: Icon | string;
  parent: 0 | 1;
  slug: string;
  taxonomy: 'service_cat';
  term_group: 0 | 1;
  term_id: number;
  term_order: string;
  term_taxonomy_id: number;
  sub_cats?: Array<Category>;
  services?: Array<Service>;
}

interface WpOptions {
  link: { title: string; url: string };
  trust: { trust_badge: string }[];
  thank_you_image: string;
  start_fee: number;
  terms: string;
  maleri_title: string;
  maleri_text: string;
}
interface CartPart {
  id: number;
  amount: number;
  price: number;
  name: string;
}

interface CartItem {
  id: number;
  price: number;
  name: string;
  amount: number;
  parts: CartPart[];
  rut: boolean;
  rot: boolean;
  green: boolean;
  start_fee: boolean;
  terms_checkout: string;
  icon?: Icon | string;
  start_fee_obj: StartFee | null;
}

export enum WidgetStyle {
  standard = 'standard',
  alternative = 'alternative',
  alternative_2 = 'alternative_2',
  alternative_3 = 'alternative_3',
}

export enum TopCategory {
  byggmax = 'category/bygg',
}

interface User {
  email: string;
  phone: string;
  ssn: string;
  firstName: string;
  lastName: string;
  street: string;
  zip: string;
  town: string;
}

interface RutOptions {
  rut_start_fee_heading: string;
  rut_start_fee_text: string;
  rut_start_fee_text_secondary: string;
}

interface RotOptions {
  rot_start_fee_heading: string;
  rot_start_fee_text: string;
  rot_start_fee_text_secondary: string;
}

interface GreenOptions {
  green_start_fee_heading: string;
  green_start_fee_text: string;
  green_start_fee_text_secondary: string;
}

interface SubSource {
  'recordId': string;
  'So_SubSource::Sus01_Name': string;
  'So_SubSource::_id': string;
  'So_SubSource::_id_Source': string;
  'modId': string;
}

interface FieldData {
  _id: string;
  So01_Name: string;
  So457_Aktiv_ac: number;
  So40_WebSubSource: string | number;
  So39_WebSource: number;
  rec_id: number;
}

interface Source {
  fieldData: FieldData;
  sub_sources: SubSource[];
}

interface SourcesRespone {
  dataInfo: {
    database: string;
    layout: string;
    table: string;
    totalRecordCount: number;
    foundCount: number;
    returnedCount: number;
  };
  data: Source[];
}

interface StartFee {
  ID: number;
  title: string;
  price: number;
  pop_up: string | null;
  discount_type: string | null;
  description: string;
}

export type {
  CartItem,
  CartPart,
  Category,
  Customer,
  CustomerCategory,
  CustomerSubCategory,
  GreenOptions,
  Icon,
  Part,
  Product,
  RotOptions,
  RutOptions,
  Service,
  Source,
  SourcesRespone,
  StartFee,
  User,
  WpOptions,
};
